import { ColumnType } from "antd/es/table";
import {
  ColumnType as CustomColumnType,
  EngagementDataSourceType,
  TableCellType,
  VotingCompanySummaryDataSource,
} from "../../models/tableModels";
import { CSVExportConfig } from "../../services/FileExport";
import { PieDatum } from "./PieCharts/EngagementsBySectorPie";
import { GeoData } from "./EngagementsByGeo";

export const STEWARDSHIP_SCREENER_PAGE_SIZE = 50;
export const STEWARDSHIP_SCREENER_BASE_COLUMNS: ColumnType<EngagementDataSourceType>[] =
  [
    {
      title: "Company Name",
      key: "company",
      dataIndex: "company",
      fixed: "left",
    },
    {
      title: "Manager",
      key: "manager_id",
      dataIndex: "manager_id",
    },
    {
      title: "Fund",
      key: "portfolio_index_id",
      dataIndex: "portfolio_index_id",
    },
    { title: "Value of Holding", key: "voh", dataIndex: "voh" },
    {
      title: "Engagement Count",
      key: "engagement_count",
      dataIndex: "engagement_count",
    },
    {
      title: "Corporate Objective Count",
      key: "corporate_objective_count",
      dataIndex: "corporate_objective_count",
    },
    {
      title: "Completed Milestones",
      key: "completed_milestones",
      dataIndex: "completed_milestones",
    },
  ];

export const STEWARDSHIP_SCREENER_COLUMN_TYPES: CustomColumnType[] = [
  { type: TableCellType.AVATAR_STACK, columnKey: "manager_id" },
  { type: TableCellType.FUND_MANAGER_BADGES, columnKey: "portfolio_index_id" },
  { type: TableCellType.COMPANY_LOGO, columnKey: "company" },
];

export const ENGAGEMENTS_BY_THEME_CONFIG: CSVExportConfig<PieDatum> = {
  filename: "engagements_by_theme.csv",
  columns: [
    { key: "label", label: "Theme" },
    { key: "value", label: "Engagements Count" },
  ],
};

export const VOTES_AGAINST_MANAGEMENT_EXPORT_CONFIG: CSVExportConfig<PieDatum> =
  {
    filename: "votes_against_management.csv",
    columns: [
      { key: "label", label: "Proposal Category" },
      { key: "value", label: "Votes Count" },
    ],
  };

export const VOTING_EXECUTION_EXPORT_CONFIG: CSVExportConfig<PieDatum> = {
  filename: "voting_execution.csv",
  columns: [
    { key: "label", label: "Voting Execution" },
    { key: "value", label: "Votes Count" },
  ],
};

export const ENGAGEMENTS_BY_GEO_CONFIG: CSVExportConfig<GeoData> = {
  filename: "engagements_by_geo.csv",
  columns: [
    { key: "id", label: "Country ISO3" },
    { key: "countryName", label: "Country Name" },
    { key: "value", label: "Engagements Count" },
  ],
};

export const VOTING_SCREENER_BASE_COLUMNS: ColumnType<VotingCompanySummaryDataSource>[] =
  [
    {
      title: "Company Name",
      key: "company",
      dataIndex: "company",
      fixed: "left",
    },
    {
      title: "Manager",
      key: "manager",
      dataIndex: "manager",
    },
    {
      title: "Proposal Categories",
      key: "categories",
      dataIndex: "categories",
    },
    {
      title: "Country",
      key: "countryIso2",
      dataIndex: "countryIso2",
    },

    {
      title: "Total / Mapped Votes Count",
      key: "total_votes_count",
      dataIndex: "total_votes_count",
      sorter: true,
    },
    {
      title: "Alignment",
      key: "alignedPct",
      dataIndex: "alignedPct",
      sorter: true,
    },
  ];

export const VOTING_SCREENER_COLUMN_TYPES: CustomColumnType[] = [
  { type: TableCellType.COMPANY_LOGO, columnKey: "company" },
  { type: TableCellType.COUNTRY_W_FLAG, columnKey: "countryIso2" },
  {
    type: TableCellType.VOTING_ALIGNMENT_BAR,
    columnKey: "alignedPct",
  },
  { type: TableCellType.TAG, columnKey: "total_votes_count" },
  { type: TableCellType.TAGS, columnKey: "categories" },
];
